import type { RootState } from "../store";

export const selectInitialized = (state: RootState) => state.app.initialized;

export const selectBrandId = (state: RootState) => state.app.brandId;

export const selectBrandCityId = (state: RootState) => state.app.brandCityId;

export const selectPointId = (state: RootState) => state.app.pointId;

export const selectMaxPreorderAmount = (state: RootState) =>
  state.app.maxPreorderAmount;

export const selectIsReadOnly = (state: RootState) => state.app.isReadOnly;

export const selectDebug = (state: RootState) => state.app.debug;

export const selectPendingEditOrderId = (state: RootState) =>
  state.app.pendingEditOrderId;

/** Режим встраивания: preorder, qr либо delivery. */
export const selectSource = (state: RootState) => state.app.source;
